import { TrackedFooter } from '@objectiv/tracker-react';
import { COUNTRY } from '~globals';
import { useSiteConfig } from '~hooks/useSiteConfig';
import { BaseLink } from '../BaseLink';
import { ComponentLink } from '~components/ComponentLink';
import { Section } from '../Section';
import { Breadcrumbs } from '../Breadcrumbs';
import { useSocials } from './useSocials';
import { useContact } from './useContact';

import InsifyLogo from './assets/insify-logo.svg';

import * as styles from './Footer.module.css';
import { Heading } from '~components/Heading';
import { Trans } from 'react-i18next';

export const Footer: React.FC = () => {
  const { footerItems } = useSiteConfig(COUNTRY);
  const socials = useSocials();
  const contact = useContact();

  return (
    <TrackedFooter objectiv={{ id: 'footer' }} className={styles.footer}>
      <Section
        className={styles.contact}
        style={
          {
            '--columns': contact.items.length,
          } as React.CSSProperties
        }
      >
        <Heading level={2} className={styles.contactTitle}>
          {contact.title}
        </Heading>
        {contact.items.map(({ Icon, link, title, subtitle }) => (
          <div key={title} className={styles.contactItem}>
            <Icon className={styles.contactIcon} />
            <Heading level={3}>{title}</Heading>
            <p>{subtitle}</p>
            <BaseLink id={link.id} href={link.url} rel='noreferrer' target='_blank'>
              {link.label}
            </BaseLink>
          </div>
        ))}
      </Section>
      <Section className={styles.sitemap}>
        <Breadcrumbs className={styles.breadcrumbs} />
        {footerItems.map((linkGroup) => (
          <div key={linkGroup.label} className={styles.linkGroup}>
            <strong className={styles.linkGroupName}>{linkGroup.label}</strong>
            {linkGroup.items.map((link) => (
              <ComponentLink key={link.label} className={styles.link} link={link}>
                {link.label}
              </ComponentLink>
            ))}
          </div>
        ))}
        <div className={styles.linkGroup}>
          <strong className={styles.linkGroupName}>{socials.label}</strong>
          <div className={styles.socialLinks}>
            {socials.items.map(({ id, Icon, url }) => (
              <BaseLink
                key={id}
                aria-label={id}
                className={styles.socialLink}
                href={url}
                rel='noreferrer'
                target='_blank'
              >
                <Icon />
              </BaseLink>
            ))}
          </div>
        </div>
        <div className={styles.footerCopyright}>
          <InsifyLogo className={styles.logo} />
          <Trans
            i18nKey='common:footer_bottom_copy'
            components={{ privacy: <BaseLink href='/voorwaarden/privacybeleid' /> }}
            values={{
              year: new Date().getFullYear(),
            }}
            parent='p'
          />
        </div>
      </Section>
    </TrackedFooter>
  );
};
